import { render, staticRenderFns } from "./DataAssetAdvertisement.vue?vue&type=template&id=984d85c4&scoped=true"
import script from "./DataAssetAdvertisement.vue?vue&type=script&lang=js"
export * from "./DataAssetAdvertisement.vue?vue&type=script&lang=js"
import style0 from "./DataAssetAdvertisement.vue?vue&type=style&index=0&id=984d85c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984d85c4",
  null
  
)

export default component.exports